// extracted by mini-css-extract-plugin
module.exports = {"new-three-w":"styles_new-three-w__1fHde","newThreeW":"styles_new-three-w__1fHde"};